import { post } from '@/utils/request'

/**
 * 多麦的订单指派归属人(只可以指派代理身份)
 * @param {object} data 请求参数
 * @param {string} data.id id
 * @param {string} data.telephone 电话
 */
export default function taoke_duomai_order_assign(data) {
  return post('taoke_duomai_order_assign', data)
}